<div mat-dialog-title style="display: flex; justify-content: space-between; align-items: center;">
  <h2 style="margin: 0;">{{'Coach Application Details' | translate}}</h2>
  <button (click)="cancel()" aria-label="Close" mat-icon-button type="button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content>
  <div class="detail-grid">
    <h3>{{'Personal Information' | translate}}</h3>
    <div class="detail-row">
      <div class="detail-item"><span class="label">{{'Name' | translate}}</span><span>{{coach?.name}}</span></div>
      <div class="detail-item"><span class="label">{{'Surname' | translate}}</span><span>{{coach?.surname}}</span></div>
      <div class="detail-item"><span class="label">{{"Father's Name" | translate}}</span><span>{{coach?.fathersName}}</span></div>
    </div>
    <div class="detail-row">
      <div class="detail-item"><span class="label">{{'Date of Birth' | translate}}</span><span>{{coach?.dateOfBirth | date:'dd/MM/yyyy'}}</span></div>
      <div class="detail-item"><span class="label">{{'Place of Birth' | translate}}</span><span>{{coach?.placeOfBirth}}</span></div>
      <div class="detail-item"><span class="label">{{'Residence' | translate}}</span><span>{{coach?.residence}}</span></div>
    </div>
    <div class="detail-row">
      <div class="detail-item"><span class="label">{{'Gender' | translate}}</span><span>{{coach?.gender}}</span></div>
      <div class="detail-item"><span class="label">{{'Nationality' | translate}}</span><span>{{coach?.nationality}}</span></div>
      <div class="detail-item"><span class="label">{{'Personal Number' | translate}}</span><span>{{coach?.personalNumber}}</span></div>
    </div>
    <div class="detail-row">
      <div class="detail-item"><span class="label">{{'Clothing Size' | translate}}</span><span>{{coach?.clothingSize}}</span></div>
      <div class="detail-item"><span class="label">{{'Phone Number' | translate}}</span><span>{{coach?.phoneNumber}}</span></div>
      <div class="detail-item"><span class="label">{{'Email' | translate}}</span><span>{{coach?.email}}</span></div>
    </div>
    <div class="detail-row">
      <div class="detail-item wide"><span class="label">{{'Address' | translate}}</span><span>{{coach?.address}}</span></div>
      <div class="detail-item"><span class="label">{{'Course' | translate}}</span><span>{{coach?.courseName}}</span></div>
    </div>

    <h3>{{'Career & Experience' | translate}}</h3>
    <div class="detail-row">
      <div class="detail-item wide"><span class="label">{{'Career as Player' | translate}}</span><span>{{coach?.careerAsPlayer}}</span></div>
    </div>
    <div class="detail-row">
      <div class="detail-item wide"><span class="label">{{'Career as Coach' | translate}}</span><span>{{coach?.careerAsCoach}}</span></div>
    </div>
    <div class="detail-row">
      <div class="detail-item wide"><span class="label">{{'Other Experience' | translate}}</span><span>{{coach?.otherExperience}}</span></div>
    </div>
    <div class="detail-row">
      <div class="detail-item wide"><span class="label">{{'Language Skills' | translate}}</span><span>{{coach?.languageSkills}}</span></div>
    </div>

    <div class="documents-header">
      <h3 style="margin: 0; border: none; padding: 0;">{{'Documents' | translate}}</h3>
      <button (click)="downloadAll()" *ngIf="documents.length" [disabled]="downloadingAll"
              color="primary" mat-stroked-button type="button">
        <mat-progress-spinner *ngIf="downloadingAll" diameter="16" mode="indeterminate" style="display:inline-block; vertical-align: middle; margin-right: 6px;"></mat-progress-spinner>
        <mat-icon *ngIf="!downloadingAll" style="vertical-align: middle;">download</mat-icon>
        {{'Download All' | translate}}
      </button>
    </div>

    <div class="detail-row documents">
      <div (click)="openPreview(doc)" *ngFor="let doc of documents" [class.downloading]="doc.downloading"
           class="document-box" role="button" tabindex="0">
        <div class="doc-thumb-wrap">
          <mat-progress-spinner *ngIf="doc.downloading" diameter="24" mode="indeterminate"></mat-progress-spinner>
          <ng-container *ngIf="!doc.downloading">
            <img (error)="doc.previewOk = false" (load)="doc.previewOk = true" *ngIf="doc.previewOk !== false"
                 [src]="doc.url" alt="" class="doc-thumb"/>
            <i *ngIf="doc.previewOk === false" class="fa {{doc.icon}}"></i>
            <div class="doc-overlay">
              <button (click)="$event.stopPropagation(); downloadDocument(doc)" aria-label="Download"
                      class="download-icon-btn" color="primary" mat-mini-fab type="button">
                <mat-icon class="download-icon">download</mat-icon>
              </button>
            </div>
          </ng-container>
        </div>
        <span class="doc-label">{{doc.label | translate}}</span>
      </div>
      <span *ngIf="!documents.length" class="no-documents">{{'No documents uploaded' | translate}}</span>
    </div>
  </div>

  <form [formGroup]="coachStatusForm">
    <div class="status-row">
      <mat-form-field appearance="outline" style="width: 250px;">
        <mat-label>{{'Status' | translate}}</mat-label>
        <mat-select formControlName="status">
          <mat-option *ngFor="let status of statuses"
                      [disabled]="coach?.status === 'REJECTED'"
                      [value]="status">{{ status }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="status-row"
         *ngIf="coachStatusForm.get('status')?.value === 'REJECTED' || coachStatusForm.get('status')?.value === 'REVIEW'">
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>{{(coachStatusForm.get('status')?.value === 'REJECTED' ? 'Rejection Comment' : 'Review Comment') | translate}}</mat-label>
        <textarea formControlName="comment" matInput rows="3"></textarea>
        <mat-error *ngIf="coachStatusForm.get('comment')?.hasError('required')">
          {{'Comment is required' | translate}}
        </mat-error>
      </mat-form-field>
    </div>

    <div mat-dialog-actions style="display: flex; justify-content: space-around">
      <button (click)="cancel()" class="loginBtn" color="primary" mat-raised-button>{{'Cancel' | translate}}</button>
      <button (click)="updateStatus()"
              [disabled]="loading || coach?.status === 'ACCEPTED' || coach?.status === 'REJECTED'"
              class="loginBtn" color="primary" mat-raised-button type="submit">
        <mat-progress-spinner *ngIf="loading" color="primary" diameter="20" mode="indeterminate"></mat-progress-spinner>
        <span *ngIf="!loading" style="color: white">{{'Update' | translate}}</span>
      </button>
    </div>
  </form>
</div>
